import React from "react";
import ButtonProps from "interfaces/ButtonProps";
import { ControlVariant } from "shared/enums/ControlVariantEnum";
import { Button as Btn, IButtonOptions } from "devextreme-react/button";
import "./styles/Controls.css";
import { ControlSize } from "shared/enums/ControlSizeEnum";
import {
  getSizeSpecificClasses,
  getControlRadius,
} from "shared/utility/ControlUtility";

export default function Button(
  props: IButtonOptions & ButtonProps
): React.ReactElement {
  const { variant, className, size, radiusSize, textSizeClass, ...rest } =
    props;

  const getVariantSpecificClasses = () => {
    if (variant === ControlVariant.primary) {
      return `border-2 border-primaryRed text-white bg-primaryRed font-extrabold hover:bg-white hover:text-primaryRed active:text-white active:border-transparent active:bg-primaryRedGrayed ${
        props.disabled ? "border-none bg-promGray3" : ""
      }`;
    }

    if (variant === ControlVariant.basic) {
      return `border-2 font-extrabold hover:text-primaryRed ${
        props.disabled ? "border-none bg-promGray3" : ""
      }`;
    }

    if (variant === ControlVariant.basicActive) {
      return `border-2 border-primaryRed font-extrabold bg-white text-primaryRed ${
        props.disabled ? "border-none bg-promGray3" : ""
      }`;
    }

    return `text-primaryRed bg-white font-bold outline-none border-none underline hover:text-promGray2 active:text-primaryRedGrayed ${
      props.disabled ? "text-promGray3" : ""
    }`;
  };

  const getClassNames = () => {
    let classNames = `py-1 font-inter ${
      textSizeClass ? textSizeClass : "text-sm"
    } ${getVariantSpecificClasses()} ${getSizeSpecificClasses(
      size
    )} ${getControlRadius(radiusSize)}`;
    return className ? `${className} ${classNames}` : classNames;
  };

  return <Btn className={getClassNames()} {...rest} />;
}

Button.defaultProps = {
  variant: ControlVariant.primary,
  size: ControlSize.Midium,
  radiusSize: ControlSize.Large,
};
